





































import {Component, Vue} from "vue-property-decorator";

import { quizdata } from "../data/quizdata";
import { Question } from "../ts/types/question";

import QuizResult from "@/components/QuizResult.vue";
import QuizAnswer from "@/components/QuizAnswer.vue";

@Component({
  components: {
    QuizResult,
    QuizAnswer
  }
})
export default class QuizTop extends Vue{

  // number of questions
  num: number = 3;

  // parameter to judge answer is showed or hidden.
  showed: boolean = false;

  /**
   * the number of correct answer
   * // TODO: This value to do destructive substitution now, bad code
   */
  correct_answer_number: number = 0;

  // list of questions
  questions: Array<Question> = this.shuffle(quizdata).slice(0, this.num);

  // calculate number of correct answer
  checkAnswer(): void {
    this.correct_answer_number = this.questions.filter(q => q.correctAnswer == q.answer).length
  }

  // check all selected
  allSelected(questions: Array<Question>): boolean {
    return questions.map(q => q.answer).includes("")
  }

  // shuffle questions
  shuffle(q: Array<Question>): Array<Question> {
    for (let i = q.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [q[i], q[j]] = [q[j], q[i]];
    }
    return q
  }

  // answer is showed or hidden?
  showAnswerClick(): void {
    this.showed = !this.showed
  }

}
